module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Reset-content"
  }, [(_vm.query.status == 'success') ? _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/user/Success.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.query.message))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.index) + "秒后自动跳转到首页，若未跳转，可"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Jump
    }
  }, [_vm._v("点击跳转")])])]) : _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/user/error.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.query.message))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.index) + "秒后自动跳转到首页，若未跳转，可"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Jump
    }
  }, [_vm._v("点击跳转")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb58b5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonResult.vue
// module id = 775
// module chunks = 1